
<div class="mwp-modal table-comp">
  @if (categroyResources) {
    <div class="body p-3">
      <div>
        <mwp-card-resource [resources]="categroyResources" tableHeader="Category Resources" [displayCloseButton]="false" [isModal]="true" [displayCategroyColumn]="false" [displayCarrierColumn]="false" />
      </div>
    </div>
  }
  @if (companyResources) {
    <div class="body px-3"> 
      <div>
        <mwp-card-resource [resources]="companyResources" tableHeader="Company Resources" [displayCloseButton]="false" [isModal]="true" [displayCategroyColumn]="false" [displayCarrierColumn]="false" />
      </div>
    </div>
  }
  <div class="d-inline-flex w-100 justify-content-center my-3">
    <button class="mwp-button-secondary" (click)="closeDialog()">
      <mwp-text-translate text="Close" jsonKey="close" />
    </button>
  </div>
</div>